// `collapsible--opened` is an example, you can use any class.
// ```slim
// div data-controller="collapsible" data-collapsible-toggle-class="collapsible--opened"
//   div data-action="click->collapsible#toggle"
//      span Collapsible Section Title
//      = svg "chevrons_half_no_shadow--top", "booking-summary--toggle"
//   .collapsible-content
//     p Click the title to toggle the visibility of this content.
// ```

stimulusApp.register(
  "collapsible-content",
  class extends Stimulus.Controller {
    static classes = ["toggle"]

    toggle() {
      requestAnimationFrame(() => {
        this.element.classList.toggle(this.toggleClass)
      })
    }
  },
)
